import React from "react";
import FacebookIcon from "./SVGs/FacebookIcon";
import InstagramIcon from "./SVGs/InstagramIcon";
import LinkedInIcon from "./SVGs/LinkedInIcon";
import TwitterIcon from "./SVGs/TwitterIcon";
import YoutubeIcon from "./SVGs/YoutubeIcon";

export default function Footer() {
  return (
    <div className="bg-black text-white p-4 md:p-12">
      <div className="w-full md:w-7/12 mx-auto">
        <div className="border-b-2 border-gray-400">
          <h2 className="my-4 text-3xl font-semibold text-center">LOGO</h2>
        </div>
        <div className="flex justify-around md:w-5/12 mx-auto my-4 mb-8">
          <TwitterIcon />
          <FacebookIcon />
          <InstagramIcon />
          <YoutubeIcon />
          <LinkedInIcon />
          <TwitterIcon />
        </div>
        <p className="uppercase text-sm md:text-base md:w-7/12 text-center mx-auto mt-12 leading-normal">
          Still have a question? No problem! Fill the{" "}
          <span className="text-primary">contact form</span> Or call us on:
          <span className="text-primary"> 081 7777 9977 01-00556584</span>
        </p>
      </div>
    </div>
  );
}
